import { useWindowSize } from "@/hooks/browser";
import { Banner } from "../Banner";
import { Skeleton } from "../Skeleton";

import "./styles.scss";

export const GridModuleSkeleton = () => {
  const screenSize = useWindowSize();

  return (
    <Banner
      small
      light
      customBgColor="neutral-50"
      wrapperSize={screenSize?.isTablet ? "xs" : "lg"}
      customClass="banner-preview"
    >
      <div className="grid-module-skeleton__header">
        <Skeleton
          width="60%"
          height="36px"
          className="grid-module-skeleton__title"
        />
        <Skeleton
          width="50%"
          height="24px"
          className="grid-module-skeleton__subtitle"
        />
      </div>

      <div className="grid-module-skeleton__content">
        <div className="grid-module-skeleton__buttons">
          {[...Array(17)].map((_, i) => (
            <div
              className="grid-module-skeleton__button"
              key={i}
            >
              <Skeleton className="grid-module-skeleton__button-icon" />
              <Skeleton
                width="100%"
                height="16px"
                className="grid-module-skeleton__button-text"
              />
            </div>
          ))}
        </div>

        <div className="grid-module-skeleton__preview-section">
          <div className="grid-module-skeleton__mobile-preview">
            <div className="grid-module-skeleton__mobile-notch" />
            <div className="grid-module-skeleton__mobile-content">
              <Skeleton
                width="80%"
                height="12px"
              />
              <Skeleton
                width="90%"
                height="80px"
                className="grid-module-skeleton__mobile-image"
              />
              <Skeleton
                width="70%"
                height="12px"
              />
              <Skeleton
                width="85%"
                height="80px"
                className="grid-module-skeleton__mobile-image"
              />
            </div>
          </div>

          <div className="grid-module-skeleton__description">
            <Skeleton
              width="100%"
              height="32px"
              className="grid-module-skeleton__description-title"
            />
            <Skeleton
              width="100%"
              height="20px"
            />
            <Skeleton
              width="95%"
              height="20px"
            />
            <Skeleton
              width="90%"
              height="20px"
            />
            <Skeleton
              width="180px"
              height="48px"
              className="grid-module-skeleton__cta-button"
            />
          </div>
        </div>
      </div>
    </Banner>
  );
};
